import { render, staticRenderFns } from "./Prototype.vue?vue&type=template&id=9000501e&"
import script from "./Prototype.vue?vue&type=script&lang=js&"
export * from "./Prototype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports